module.exports = __webpack_public_path__ + "img/turnover.0c81a557.png";